import React, { useState, useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    ClickAwayListener,
    Grid,
    FormControl,
    InputLabel,
    OutlinedInput,
    FormHelperText,
    Button,
    Typography,
    IconButton,
    Stack,
    Divider
} from '@mui/material';
import ImageUpload from 'Components/Icons/ImageUpload';
import { Formik, useField, useFormikContext } from 'formik';
import * as Yup from 'yup';
import axios from 'utils/axios';
import { SET_LOADING, SET_TOAST_OBJECT } from 'store/actions';
import { updateCompanyQuery, uploadCompanyLogo } from 'utils/apolloQueries';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { SET_COMPANY_DATA } from 'store/actions';
import DeleteCompany from './DeleteCompany';
import imageCompression from 'browser-image-compression';
import { MAX_FILE_CONTENT, MAX_FILE_SIZE, compressorOptions } from './constants';
import { FileUploader } from 'react-drag-drop-files';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { IconCloudUpload } from '@tabler/icons';
import CompanyProfileImage from './CompanyProfileImage';
import CompanyLink from './CompanyLinks';
import { hasNoPermissionToEdit } from 'helper/permission.helper';
import { PermissionTypes } from 'Components/PermissionWrapper/constants';

const fileTypes = ['JPG', 'PNG', 'GIF'];
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '562px',
    bgcolor: 'background.paper',
    borderRadius: '12px',
    boxShadow: '0px 0px 15px 0px rgba(0, 5, 124, 0.13)',
    p: 5
};

const accessToken = localStorage.getItem('diologAuthToken');
const apiKey = process.env.REACT_APP_ACT_GMAP_API_KEY;
const mapApiJs = 'https://maps.googleapis.com/maps/api/js';

function UpdateProfile() {
    const authentication = useSelector((state) => state.authentication);
    let { companyCreator, pagePermissions } = authentication;
    const theme = useTheme();
    const dispatch = useDispatch();
    const { companyProfile, companyData } = useSelector((state) => state.customization);
    const [modalOpen, setModalOpen] = useState(false);
    const [uploadLogoModalOpen, setUploadLogoModalOpen] = useState(false);
    const [errorHandle, setErrorHandle] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [profilePicture, setProfilePicture] = useState(companyData?.companyLogo || '');
    const [addValue, setAddValue] = useState('');
    const searchInput = useRef(null);
    const [errorMessage, setErrorMessage] = useState('');
    const hasEditNoPermission = hasNoPermissionToEdit(PermissionTypes.companyDetails, pagePermissions);
    // const handleImageChange = (file) => {
    //     setFile(file);
    // };

    const handleUploadLogoOpen = () => setUploadLogoModalOpen(true);
    const handleUploadLogoClose = () => setUploadLogoModalOpen(false);

    const handleDeleteModal = () => {
        setModalOpen(true);
    };

    useEffect(() => {
        if (companyData?.companyLogo) {
            setProfilePicture(companyData?.companyLogo || '');
        }
    }, [companyData]);

    const fileHandle = async (file) => {
        let uploadedFile = file;
        setErrorMessage('');
        // dispatch({ type: SET_TOAST_OBJECT, toastObject: { status: false } });
        if (uploadedFile) {
            if (uploadedFile.size / 1024 >= MAX_FILE_SIZE) {
                setErrorMessage(`Maximum file size of ${MAX_FILE_CONTENT} exceeded. Please choose smaller size image.`);
            } else if (uploadedFile.type !== 'image/jpeg' && uploadedFile.type !== 'image/png') {
                setErrorMessage('Unsupported file format. Please upload .jpeg/.jpg/.png file.');
            } else {
                if (uploadedFile) {
                    uploadedFile = await imageCompression(uploadedFile, compressorOptions);
                    setSelectedFile(uploadedFile);
                    setProfilePicture(URL.createObjectURL(uploadedFile));
                } else {
                    setProfilePicture(companyProfile);
                }
            }
        }
    };
    const uploadLogo = async () => {
        try {
            let obj = { status: false };
            let file = await uploadFile();
            if (file !== undefined) {
                let latValue = null;
                let longValue = null;
                if (companyData.location && companyData.location.coordinates) {
                    latValue = companyData.location.coordinates[1];
                    longValue = companyData.location.coordinates[0];
                }
                let variables = {
                    updateCompanyInput: {
                        about: companyData?.about || '',
                        addressLineTwo: companyData.addressLineTwo,
                        addressLineOne: companyData.addressLineOne,
                        companyId: companyData._id,
                        companyLogo: file,
                        email: companyData.email,
                        latitude: latValue,
                        legalBusinessName: companyData.legalBusinessName,
                        longitude: longValue,
                        optionalBusinessName: companyData.optionalBusinessName,
                        phoneNumber: companyData.phoneNumber,
                        postCode: parseFloat(companyData.postCode),
                        state: companyData?.state,
                        suburb: companyData?.suburb,
                        websiteUrl: companyData.websiteUrl,
                        companyLinks: sanitizedItems(companyData?.companyLinks || [])
                    }
                };
                const submitData = { query: updateCompanyQuery, variables: variables };
                if (accessToken) {
                    axios({
                        method: 'POST',
                        data: submitData,
                        headers: { Authorization: accessToken }
                    })
                        .then(function (response) {
                            if (response.status === 200) {
                                if (response.data) {
                                    dispatch({ type: SET_LOADING, loading: false });
                                    if (response.data.errors) {
                                        var msg = response.data.errors[0].message;
                                        if (response.data.errors[0].extensions.response.message) {
                                            msg = response.data.errors[0].extensions.response.message;
                                        }
                                        msg = msg;
                                        obj = {
                                            status: true,
                                            variant: 'warning',
                                            message: msg
                                        };
                                    } else if (response.data.data) {
                                        obj = {
                                            status: true,
                                            variant: 'success',
                                            message: 'Company logo updated sucessfully'
                                        };
                                        dispatch({ type: SET_COMPANY_DATA, companyData: response.data.data.updateCompany });
                                        setProfilePicture(file);
                                        setSelectedFile(null);
                                        handleUploadLogoClose();
                                        setErrorMessage('');
                                    }
                                    dispatch({
                                        type: SET_TOAST_OBJECT,
                                        toastObject: obj
                                    });
                                }
                            }
                        })
                        .catch(function (response) {
                            // console.log(response);
                            dispatch({ type: SET_LOADING, loading: false });
                            obj = {
                                status: true,
                                variant: 'error',
                                message: 'Something went wrong. Please try again later.'
                            };
                            dispatch({
                                type: SET_TOAST_OBJECT,
                                toastObject: obj
                            });
                        });
                } else {
                    obj = {
                        status: true,
                        variant: 'error',
                        message: 'Something went wrong. Please try again later.'
                    };
                    dispatch({ type: SET_LOADING, loading: false });
                    dispatch({
                        type: SET_TOAST_OBJECT,
                        toastObject: obj
                    });
                }
            }
        } catch (err) {
            obj = {
                status: true,
                variant: 'error',
                message: 'Something went wrong. Please try again later.'
            };
            dispatch({ type: SET_LOADING, loading: false });
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: obj
            });
        }
    };

    const uploadFile = async () => {
        let pictureKey = companyData.companyLogo;
        if (selectedFile) {
            let o = {
                query: uploadCompanyLogo,
                variables: {
                    file: null
                }
            };
            let map = {
                0: ['variables.file']
            };
            let fd = new FormData();
            fd.append('operations', JSON.stringify(o));
            fd.append('map', JSON.stringify(map));
            fd.append(0, selectedFile);
            const result = await axios({
                method: 'POST',
                data: fd,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: accessToken
                }
            })
                .then(function (response) {
                    if (response.status === 200) {
                        if (response.data) {
                            pictureKey = response.data.data.uploadCompanyLogo.key;
                            if (pictureKey) {
                                return pictureKey;
                            } else {
                                console.log(response);
                                setErrorHandle(true);
                                return pictureKey;
                            }
                        }
                    } else {
                        console.log(response);
                        setErrorHandle(true);
                        return pictureKey;
                    }
                })
                .catch(function (response) {
                    console.log(response);
                    setErrorHandle(true);
                    return pictureKey;
                });
            return result;
        } else {
            return pictureKey;
        }
    };
    useEffect(() => {
        if (errorHandle === true) {
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    message: 'Something went wrong. Please try again later',
                    variant: 'error'
                }
            });
            dispatch({ type: SET_LOADING, loading: false });
        }
    }, [errorHandle]);
    // useEffect(() => {
    //     setProfilePicture(companyProfile);
    // }, [companyProfile]);
    const [address, setAddress] = useState({});
    function loadAsyncScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            Object.assign(script, {
                type: 'text/javascript',
                async: true,
                src
            });
            script.addEventListener('load', () => resolve(script));
            document.head.appendChild(script);
        });
    }
    const extractAddress = (place) => {
        const address = {
            city: '',
            state: '',
            zip: '',
            country: '',
            location: '',
            plain() {
                const city = this.city ? this.city + ', ' : '';
                const zip = this.zip ? this.zip + ', ' : '';
                const state = this.state ? this.state + ', ' : '';
                const location = this.location ? this.location + ', ' : '';
                const lat = this.lat ? this.lat + ', ' : '';
                const lng = this.lng ? this.lng + ', ' : '';
                return city + zip + state + this.country + location + lat + lng;
            }
        };
        if (!Array.isArray(place?.address_components)) {
            return address;
        }
        place.address_components.forEach((component) => {
            const types = component.types;
            const value = component.long_name;
            if (types.includes('locality')) {
                address.city = value;
            }
            if (types.includes('administrative_area_level_1')) {
                address.state = value;
            }
            if (types.includes('postal_code')) {
                address.zip = value;
            }
            if (types.includes('country')) {
                address.country = value;
            }
        });
        if (place.formatted_address) {
            address.location = place.formatted_address;
        }
        if (place.geometry.location.lat()) {
            address.lat = place.geometry.location.lat();
        }
        if (place.geometry.location.lng()) {
            address.lng = place.geometry.location.lng();
        }
        return address;
    };
    const AutoFillField = (props) => {
        const {
            values: { addressLineOne },
            touched,
            setFieldValue
        } = useFormikContext();
        const [field, meta] = useField(props);
        useEffect(() => {
            if (props.address) {
                setFieldValue(props.name, props.address);
            }
        }, [addressLineOne, touched.addressLineOne, setFieldValue, address]);
        let disabledField = true;
        if (Object.getOwnPropertyNames(address).length === 0) {
            disabledField = false;
        }
        if (Object.getOwnPropertyNames(address).length !== 0 && addressLineOne == '') {
            setAddress({});
            setFieldValue('suburb', '');
            setFieldValue('state', '');
            setFieldValue('postCode', '');
        }
        if (props.address == '') {
            disabledField = false;
        }
        return (
            <>
                <OutlinedInput
                    id="outlined-adornment-postCode"
                    type="text"
                    name="postCode"
                    label="Post code"
                    inputProps={{}}
                    {...props}
                    {...field}
                    disabled={disabledField || props.disabled}
                />
            </>
        );
    };
    // init gmap script
    const initMapScript = () => {
        // if script already loaded
        if (window.google && window.google.maps) {
            return Promise.resolve();
        }
        const src = `${mapApiJs}?key=${apiKey}&libraries=places`;
        return loadAsyncScript(src);
    };
    // do something on address change
    const DebouncedGetPlace = (autocomplete) => autocomplete.getPlace();
    const onChangeAddress = (autocomplete) => {
        const place = DebouncedGetPlace(autocomplete);
        setAddress(extractAddress(place));
    };
    // init autocomplete
    const initAutocomplete = () => {
        if (!searchInput.current) return;
        const autocomplete = new window.google.maps.places.Autocomplete(searchInput.current, {
            componentRestrictions: { country: 'au' }
        });
        autocomplete.addListener('place_changed', () => onChangeAddress(autocomplete));
    };
    useEffect(() => {
        initMapScript().then(() => initAutocomplete());
    }, []);
    useEffect(() => {
        setAddValue(companyData.addressLineOne);
    }, [companyData]);
    const sanitizedItems = (itemsLink) => itemsLink.map(({ __typename, ...rest }) => rest);
    return (
        <>
            <Grid item xs={12} md={8} lg={9} className="card-content update-profile-card-content">
                <Formik
                    initialValues={{
                        email: companyData.email ? companyData.email : '',
                        mobileNum: companyData.phoneNumber ? companyData.phoneNumber : '',
                        addressLineOne: companyData.addressLineOne ? companyData.addressLineOne : '',
                        addressLineTwo: companyData.addressLineTwo ? companyData.addressLineTwo : '',
                        suburb: companyData.suburb ? companyData.suburb : '',
                        state: companyData.state ? companyData.state : '',
                        postCode: companyData.postCode ? companyData.postCode : '',
                        websiteUrl: companyData.websiteUrl ? companyData.websiteUrl : '',
                        about: companyData.about ? companyData.about : '',
                        legalBusinessName: companyData.legalBusinessName ? companyData.legalBusinessName : '',
                        abn: companyData.abn ? companyData.abn : '',
                        optionalBusinessName: companyData.optionalBusinessName ? companyData.optionalBusinessName : '',
                        asxCode: companyData.asxCode ? companyData.asxCode : ''
                    }}
                    validationSchema={Yup.object().shape({
                        legalBusinessName: Yup.string().required('Business name is required'),
                        email: Yup.string().email('Invalid email address').required('Email address is required'),
                        mobileNum: Yup.string().matches(/^\d{10}$/, 'Phone number is not valid'),
                        abn: Yup.string().matches(/^[0-9]*$/, 'must be numeric values'),
                        // .length(11, 'Must be 11 digits'),
                        // asxCode: Yup.string().required('AXS code is required'),
                        websiteUrl: Yup.string()
                            .required('Website URL is required')
                            .matches(
                                /^((https?|ftp):\/\/)?(www.)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
                                'Invalid URL format'
                            ),
                        about: Yup.string().required('About is required'),
                        optionalBusinessName: Yup.string(),
                        addressLineOne: Yup.string().required('Address line 1 is required'),
                        addressLineTwo: Yup.string(),
                        suburb: Yup.string(),
                        state: Yup.string().required('State is required'),
                        postCode: Yup.string()
                            .required('Postal code is required')
                            .matches(/^[0-9]{4,5}$/, 'Invalid Postal code')
                    })}
                    enableReinitialize={true}
                    onSubmit={async (values, { resetForm }) => {
                        let obj = { status: false };
                        // dispatch({ type: SET_TOAST_OBJECT, toastObject: obj });
                        dispatch({ type: SET_LOADING, loading: true });
                        setErrorHandle(false);
                        try {
                            let file = await uploadFile();
                            if (file !== undefined) {
                                let latValue = null;
                                let longValue = null;
                                if (companyData.location && companyData.location.coordinates) {
                                    latValue = companyData.location.coordinates[1];
                                    longValue = companyData.location.coordinates[0];
                                }
                                let phoneNumber = values.mobileNum;
                                let variables = {
                                    updateCompanyInput: {
                                        about: values.about,
                                        addressLineTwo: values.addressLineTwo,
                                        addressLineOne: address.location ? address.location : values.addressLineOne,
                                        companyId: companyData._id,
                                        companyLogo: file,
                                        email: values.email,
                                        latitude: address.lat ? address.lat : latValue,
                                        legalBusinessName: values.legalBusinessName,
                                        longitude: address.lng ? address.lng : longValue,
                                        optionalBusinessName: values.optionalBusinessName,
                                        phoneNumber: phoneNumber,
                                        postCode: parseFloat(values.postCode),
                                        state: address.state ? address.state : values.state,
                                        suburb: address.city ? address.city : values.suburb,
                                        websiteUrl: values.websiteUrl,
                                        companyLinks: sanitizedItems(companyData?.companyLinks || [])
                                    }
                                };
                                const submitData = { query: updateCompanyQuery, variables: variables };
                                if (accessToken) {
                                    axios({
                                        method: 'POST',
                                        data: submitData,
                                        headers: { Authorization: accessToken }
                                    })
                                        .then(function (response) {
                                            if (response.status === 200) {
                                                if (response.data) {
                                                    dispatch({ type: SET_LOADING, loading: false });
                                                    if (response.data.errors) {
                                                        var msg = response.data.errors[0].message;
                                                        if (response.data.errors[0].extensions.response.message) {
                                                            msg = response.data.errors[0].extensions.response.message;
                                                        }
                                                        msg = msg;
                                                        obj = {
                                                            status: true,
                                                            variant: 'warning',
                                                            message: msg
                                                        };
                                                    } else if (response.data.data) {
                                                        obj = {
                                                            status: true,
                                                            variant: 'success',
                                                            message: 'Company profile update sucessful'
                                                        };
                                                        dispatch({ type: SET_COMPANY_DATA, companyData: response.data.data.updateCompany });
                                                        setProfilePicture(file);
                                                        setSelectedFile(null);
                                                    }
                                                    dispatch({
                                                        type: SET_TOAST_OBJECT,
                                                        toastObject: obj
                                                    });
                                                }
                                            }
                                        })
                                        .catch(function (response) {
                                            console.log(response);
                                            dispatch({ type: SET_LOADING, loading: false });
                                            obj = {
                                                status: true,
                                                variant: 'error',
                                                message: 'Something went wrong. Please try again later.'
                                            };
                                            dispatch({
                                                type: SET_TOAST_OBJECT,
                                                toastObject: obj
                                            });
                                        });
                                } else {
                                    obj = {
                                        status: true,
                                        variant: 'error',
                                        message: 'Something went wrong. Please try again later.'
                                    };
                                    dispatch({ type: SET_LOADING, loading: false });
                                    dispatch({
                                        type: SET_TOAST_OBJECT,
                                        toastObject: obj
                                    });
                                }
                            }
                        } catch (err) {
                            obj = {
                                status: true,
                                variant: 'error',
                                message: 'Something went wrong. Please try again later.'
                            };
                            dispatch({ type: SET_LOADING, loading: false });
                            dispatch({
                                type: SET_TOAST_OBJECT,
                                toastObject: obj
                            });
                        }
                    }}
                >
                    {({ errors, handleBlur, handleChange, handleSubmit, touched, values, setFieldValue }) => (
                        <form noValidate onSubmit={handleSubmit} id="update-profile">
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: '20px',
                                    [theme.breakpoints.down('lg')]: {
                                        width: 'auto'
                                    }
                                }}
                            >
                                <Box>
                                    <CompanyProfileImage
                                        profilePicture={profilePicture}
                                        legalBusinessName={companyData.legalBusinessName}
                                        isFile={selectedFile ? true : false}
                                    />
                                </Box>
                                <Box className="profile-head">
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Button
                                                variant="outlined warning"
                                                startIcon={<ImageUpload className="" />}
                                                className="medium warning warning-icon warning-text icon-yellow-fill icon-hover-clear-fill"
                                                // component="label"
                                                disableRipple
                                                disabled={hasEditNoPermission}
                                                onClick={handleUploadLogoOpen}
                                            >
                                                Upload company logo
                                                {/* <input type="file" hidden onChange={fileHandle} /> */}
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', fontSize: '11px', pt: '3px' }}>
                                            <InfoOutlinedIcon sx={{ mr: '4px', width: '12px', height: '12px', mb: '2px' }} />
                                            Image size Limit should be {MAX_FILE_CONTENT} Max.
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>

                            <Grid container className="profile-fields">
                                <Grid item xs={12} md={6} lg={5}>
                                    <FormControl
                                        fullWidth
                                        error={Boolean(touched.email && errors.email)}
                                        sx={{ ...theme.typography.customInput }}
                                    >
                                        <InputLabel htmlFor="outlined-adornment-email-login">Email</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-email"
                                            type="text"
                                            value={values.email}
                                            name="email"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            label="Email"
                                            inputProps={{}}
                                            disabled={hasEditNoPermission}
                                        />
                                        {touched.email && errors.email && (
                                            <FormHelperText error id="standard-weight-helper-text-email-login">
                                                {errors.email}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={5}>
                                    <FormControl
                                        fullWidth
                                        error={Boolean(touched.mobileNum && errors.mobileNum)}
                                        sx={{ ...theme.typography.customInput }}
                                    >
                                        <InputLabel htmlFor="outlined-adornment-mobileNum-login">Phone number</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-mobileNum"
                                            type="text"
                                            value={values.mobileNum}
                                            name="mobileNum"
                                            onBlur={handleBlur}
                                            disabled={hasEditNoPermission}
                                            onChange={handleChange}
                                            label="Phone number"
                                            inputProps={{}}
                                        />
                                        {touched.mobileNum && errors.mobileNum && (
                                            <FormHelperText error id="standard-weight-helper-text-mobileNum-login">
                                                {errors.mobileNum}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={5}>
                                    <FormControl
                                        fullWidth
                                        error={Boolean(touched.addressLineOne && errors.addressLineOne)}
                                        sx={{ ...theme.typography.customInput }}
                                        disabled={hasEditNoPermission}
                                    >
                                        <div className="search">
                                            <InputLabel htmlFor="outlined-adornment-email-login">Address line 1</InputLabel>
                                            <ClickAwayListener
                                                disableReactTree={hasEditNoPermission}
                                                onClickAway={() => {
                                                    if (address.location) {
                                                        setAddValue(address.location);
                                                    } else {
                                                        setFieldValue('addressLineOne', addValue);
                                                    }
                                                    // {
                                                    //     address.location
                                                    //         ? setAddValue(address.location)
                                                    //         : setAddValue(values.addressLineOne) &&
                                                    //           setFieldValue('addressLineOne', addValue);
                                                    // }
                                                }}
                                            >
                                                <input
                                                    id="outlined-adornment-addressLineOne"
                                                    className="address-line-1"
                                                    type="text"
                                                    name="addressLineOne"
                                                    onBlur={handleBlur}
                                                    label="Address line 1"
                                                    disabled={hasEditNoPermission}
                                                    ref={searchInput}
                                                    onChange={(e) => setAddValue(e.target.value)}
                                                    value={addValue ? addValue : ''}
                                                />
                                            </ClickAwayListener>
                                        </div>
                                        {touched.addressLineOne && errors.addressLineOne && (
                                            <FormHelperText error id="standard-weight-helper-text-email-login">
                                                {errors.addressLineOne}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={5}>
                                    <FormControl
                                        fullWidth
                                        error={Boolean(touched.addressLineTwo && errors.addressLineTwo)}
                                        sx={{ ...theme.typography.customInput }}
                                        disabled={hasEditNoPermission}
                                    >
                                        <InputLabel htmlFor="outlined-adornment-email-login">Address line 2 (Optional)</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-addressLineTwo"
                                            type="text"
                                            value={values.addressLineTwo}
                                            name="addressLineTwo"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            disabled={hasEditNoPermission}
                                            label="Address line 2 (Optional)"
                                            inputProps={{}}
                                        />
                                        {touched.addressLineTwo && errors.addressLineTwo && (
                                            <FormHelperText error id="standard-weight-helper-text-email-login">
                                                {errors.addressLineTwo}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} lg={10}>
                                    <FormControl
                                        fullWidth
                                        error={Boolean(touched.suburb && errors.suburb)}
                                        sx={{ ...theme.typography.customInput }}
                                        disabled={hasEditNoPermission}
                                    >
                                        <InputLabel disabled={hasEditNoPermission} htmlFor="outlined-adornment-email-login">
                                            Suburb
                                        </InputLabel>
                                        <AutoFillField disabled={hasEditNoPermission} name="suburb" address={address.city}></AutoFillField>

                                        {touched.suburb && errors.suburb && (
                                            <FormHelperText error id="standard-weight-helper-text-email-login">
                                                {errors.suburb}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={5}>
                                    <FormControl
                                        fullWidth
                                        error={Boolean(touched.state && errors.state)}
                                        sx={{ ...theme.typography.customInput }}
                                        disabled={hasEditNoPermission}
                                    >
                                        <InputLabel disabled={hasEditNoPermission} htmlFor="outlined-adornment-email-login">
                                            State
                                        </InputLabel>
                                        <AutoFillField disabled={hasEditNoPermission} name="state" address={address.state}></AutoFillField>
                                        {touched.state && errors.state && (
                                            <FormHelperText error id="standard-weight-helper-text-email-login">
                                                {errors.state}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={5}>
                                    <FormControl
                                        fullWidth
                                        error={Boolean(touched.postCode && errors.postCode)}
                                        sx={{ ...theme.typography.customInput }}
                                        disabled={hasEditNoPermission}
                                    >
                                        <InputLabel disabled={hasEditNoPermission} htmlFor="outlined-adornment-email-login">
                                            Post code
                                        </InputLabel>
                                        <AutoFillField disabled={hasEditNoPermission} name="postCode" address={address.zip}></AutoFillField>
                                        {touched.postCode && errors.postCode && (
                                            <FormHelperText error id="standard-weight-helper-text-email-login">
                                                {errors.postCode}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} lg={10}>
                                    <FormControl
                                        fullWidth
                                        error={Boolean(touched.about && errors.about)}
                                        sx={{ ...theme.typography.customInput }}
                                        className="mt-0 contact-textarea-formcontrol"
                                        disabled={hasEditNoPermission}
                                    >
                                        <InputLabel htmlFor="outlined-adornment-about-login">About</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-about-login"
                                            type="about"
                                            value={values.about}
                                            name="about"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            disabled={hasEditNoPermission}
                                            label="About"
                                            multiline
                                        />
                                        {touched.about && errors.about && (
                                            <FormHelperText error id="standard-weight-helper-text-about-login">
                                                {errors.about}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} lg={10}>
                                    <FormControl
                                        fullWidth
                                        error={Boolean(touched.websiteUrl && errors.websiteUrl)}
                                        sx={{ ...theme.typography.customInput }}
                                    >
                                        <InputLabel htmlFor="outlined-adornment-email-login">Website</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-websiteUrl"
                                            type="text"
                                            value={values.websiteUrl}
                                            name="websiteUrl"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            label="Website"
                                            disabled={hasEditNoPermission}
                                            inputProps={{}}
                                        />
                                        {touched.websiteUrl && errors.websiteUrl && (
                                            <FormHelperText error id="standard-weight-helper-text-email-login">
                                                {errors.websiteUrl}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={5}>
                                    <FormControl
                                        fullWidth
                                        error={Boolean(touched.legalBusinessName && errors.legalBusinessName)}
                                        sx={{ ...theme.typography.customInput }}
                                    >
                                        <InputLabel htmlFor="outlined-adornment-email-login">Legal business name</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-legalBusinessName"
                                            type="text"
                                            value={values.legalBusinessName}
                                            name="legalBusinessName"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            label="Legal business name"
                                            inputProps={{}}
                                            disabled={hasEditNoPermission}
                                        />
                                        {touched.legalBusinessName && errors.legalBusinessName && (
                                            <FormHelperText error id="standard-weight-helper-text-email-login">
                                                {errors.legalBusinessName}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={5}>
                                    <FormControl
                                        fullWidth
                                        error={Boolean(touched.abn && errors.abn)}
                                        sx={{ ...theme.typography.customInput }}
                                        className="semi-trans"
                                    >
                                        <InputLabel htmlFor="outlined-adornment-email-login">Australian business number</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-abn"
                                            type="text"
                                            value={values.abn}
                                            name="abn"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            label="Australian business number"
                                            disabled
                                            inputProps={{}}
                                        />
                                        {touched.abn && errors.abn && (
                                            <FormHelperText error id="standard-weight-helper-text-email-login">
                                                {errors.abn}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={5}>
                                    <FormControl
                                        fullWidth
                                        error={Boolean(touched.optionalBusinessName && errors.optionalBusinessName)}
                                        sx={{ ...theme.typography.customInput }}
                                    >
                                        <InputLabel htmlFor="outlined-adornment-email-login">Doing business as (Optional)</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-optionalBusinessName"
                                            type="text"
                                            value={values.optionalBusinessName}
                                            name="optionalBusinessName"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            label="Doing business as (optional)"
                                            inputProps={{}}
                                            disabled={hasEditNoPermission}
                                        />
                                        {touched.optionalBusinessName && errors.optionalBusinessName && (
                                            <FormHelperText error id="standard-weight-helper-text-email-login">
                                                {errors.optionalBusinessName}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={5}>
                                    <FormControl
                                        fullWidth
                                        error={Boolean(touched.asxCode && errors.asxCode)}
                                        sx={{ ...theme.typography.customInput }}
                                        className="semi-trans"
                                    >
                                        <InputLabel htmlFor="outlined-adornment-email-login">ASX code</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-asxCode"
                                            type="text"
                                            value={values.asxCode}
                                            name="asxCode"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            label="ASX code"
                                            inputProps={{}}
                                            disabled
                                        />
                                        {touched.asxCode && errors.asxCode && (
                                            <FormHelperText error id="standard-weight-helper-text-email-login">
                                                {errors.asxCode}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid xs={12}>
                                    <Divider variant="fullWidth" />
                                </Grid>
                                <Grid item xs={12} md={12} lg={12}>
                                    <CompanyLink />
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </Grid>

            <Grid item xs={12} className="card-footer">
                <Grid container>
                    <Grid item xs={12} md={4} lg={3}></Grid>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12}>
                                <Button
                                    className="alternate-reversed large"
                                    onClick={() => {
                                        handleDeleteModal();
                                    }}
                                    disabled={!companyCreator}
                                >
                                    Remove company
                                </Button>
                                <Button className="alternate large" type="submit" form="update-profile" disabled={hasEditNoPermission}>
                                    Save changes
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <DeleteCompany modalOpen={modalOpen} setModalOpen={setModalOpen} />

            <Modal
                open={uploadLogoModalOpen}
                onClose={() => {
                    handleUploadLogoClose();
                    setErrorMessage('');
                    setSelectedFile(null);
                    setProfilePicture(companyData?.companyLogo || '');
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <IconButton
                        onClick={() => {
                            handleUploadLogoClose();
                            setErrorMessage('');
                            setSelectedFile(null);
                            setProfilePicture(companyData?.companyLogo || '');
                        }}
                        sx={{
                            position: 'absolute',
                            top: '16px',
                            right: '16px',
                            color: '#FCB413',
                            padding: '0',
                            width: '24px',
                            height: '24px'
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Stack rowGap="24px">
                        <Typography fontFamily="Poppins, Sans-serif" variant="h2" component="h2" fontWeight="600">
                            Upload company logo
                        </Typography>
                        <Box textAlign="center">
                            <Box
                                sx={{
                                    border: '1px solid #FBB414',
                                    borderRadius: '50%',
                                    width: '96px',
                                    height: '96px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto'
                                }}
                            >
                                {/* <Avatar
                                    src={profilePicture ? profilePicture : companyPlaceholderImage}
                                    alt={profilePicture ? profilePicture.name : 'Placeholder'}
                                    sx={{ width: '96px', height: '96px' }}
                                /> */}

                                <CompanyProfileImage
                                    profilePicture={profilePicture}
                                    legalBusinessName={companyData.legalBusinessName}
                                    isFile={selectedFile ? true : false}
                                    isModal={true}
                                    width={'96px'}
                                    height={'96px'}
                                />
                            </Box>
                        </Box>
                        <Box>
                            <FileUploader
                                handleChange={fileHandle}
                                name="file"
                                types={fileTypes}
                                disabled={hasEditNoPermission}
                                onTypeError={() => {
                                    setErrorMessage('Please upload PNG or JPG files (max 5MB).');
                                }}
                            >
                                <Stack
                                    className="upload-logo"
                                    rowGap="16px"
                                    sx={{
                                        borderRadius: '12px',
                                        border: '1px dashed #e5e5e8',
                                        padding: '12px'
                                    }}
                                    alignItems="center"
                                >
                                    <Box>
                                        <IconCloudUpload size={38} className="icon-primary" />
                                    </Box>
                                    <Typography sx={{ color: '#B8B8B8', fontSize: '1rem', lineHeight: '1.22917', fontWeight: '500' }}>
                                        Drop here to upload
                                    </Typography>
                                    <Typography sx={{ color: '#B8B8B8', fontSize: '0.6875rem', lineHeight: '1.78788' }}>
                                        Upload JPG, PNG (max 5MB)
                                    </Typography>
                                </Stack>
                            </FileUploader>
                            {errorMessage && (
                                <Typography
                                    sx={{
                                        color: '#F00',
                                        fontSize: '0.75rem',
                                        lineHeight: '2'
                                    }}
                                    mt={1}
                                >
                                    {errorMessage}
                                </Typography>
                            )}
                        </Box>
                        <Stack flexDirection="row" gap="8px" justifyContent="flex-end">
                            <Button
                                variant="outlined"
                                color="secondary"
                                size="large"
                                className="alternate-reversed"
                                style={{ width: '157px' }}
                                disableRipple
                                disabled={hasEditNoPermission}
                                onClick={() => {
                                    handleUploadLogoClose();
                                    setErrorMessage('');
                                    setProfilePicture(companyProfile);
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="secondary"
                                size="large"
                                className="alternate"
                                style={{ width: '157px' }}
                                disableRipple
                                disabled={!profilePicture || errorMessage || hasEditNoPermission}
                                onClick={uploadLogo}
                            >
                                Save
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        </>
    );
}

export default UpdateProfile;
